/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * All possible event states, used to indicate badges in front-end.
 */
export type EventStateEnum = 'PENDING' | 'DECLINED' | 'POSTPONED' | 'REFUNDABLE' | 'SOLD_OUT' | 'SALE_WITH_CODE' | 'TICKETS_CURRENTLY_UNAVAILABLE' | 'PRE_SALE_ENDED';

export const EventStateEnum = {
    Pending: 'PENDING' as EventStateEnum,
    Declined: 'DECLINED' as EventStateEnum,
    Postponed: 'POSTPONED' as EventStateEnum,
    Refundable: 'REFUNDABLE' as EventStateEnum,
    SoldOut: 'SOLD_OUT' as EventStateEnum,
    SaleWithCode: 'SALE_WITH_CODE' as EventStateEnum,
    TicketsCurrentlyUnavailable: 'TICKETS_CURRENTLY_UNAVAILABLE' as EventStateEnum,
    PreSaleEnded: 'PRE_SALE_ENDED' as EventStateEnum
};

